import React from 'react';
import { View } from 'ui';

const Dashboard = () => {
  return <View title="Dashboard" iconClass="fas fa-tachometer-alt"></View>;
};

export default Dashboard;
